module.exports = __webpack_public_path__ + "static/img/icon_hitem9.57603c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem9.png
// module id = 8xNg
// module chunks = 21